import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Icon, Table } from 'libs.nucleus';
import { useDateTime } from 'libs.react';
import { usePIOversightDetailsTableColumns } from '../hooks/pi_oversight_details_table_columns.hook';
const DCRItems = ({ dcrItems }) => {
    const { parseDateTimeShort } = useDateTime();
    const { dcrItemsTableColumns } = usePIOversightDetailsTableColumns();
    if (dcrItems.length === 0) {
        return null;
    }
    return (_jsx("div", { "data-testid": 'dcr-items-section', className: 'border-b border-gray-300 mb-8 last:border-b-0 last:mb-0', children: dcrItems.map((dcrItem) => {
            return (_jsxs("div", { className: 'border-b border-gray-300 pb-8 mb-8 last:border-b-0 last:mb-0', "data-testid": 'dcr-item', children: [_jsxs("div", { className: 'flex items-center gap-1 mb-2', children: [_jsx(Icon, { name: 'edit', color: 'primary', size: 'sm' }), _jsx("span", { className: 'text-sm text-text-secondary', children: parseDateTimeShort(dcrItem.timestamp) })] }), _jsx("p", { className: 'text-lg font-semibold mb-8', children: dcrItem.dcrNumber }), _jsx(Table, { columns: dcrItemsTableColumns, data: [dcrItem], labelNoResults: '', hasPagination: false, getRowId: (row) => row.dcrNumber })] }, dcrItem.dcrNumber));
        }) }));
};
export default DCRItems;
